import type { ProductFragmentEnhanced } from '@models/enhanced-fragments';
import Image from 'next/image';
import type { UnitSystem } from '@icommerce/units';
import styles from './AttributeIconArea.module.css';
import type { TechnicalDataAttributes } from '@libs/technical-data';
import { isTechnicalDataAttributeAndNotLegacyConfig } from '@libs/technical-data';
import type { LabeledAttribute, ProductAttribute, ProductAttributeValueAmountUnit } from '@libs/attribute.helper';
import { getAttributeDisplayValue, getAttributeValue } from '@libs/attribute.helper';

export interface AttributeIconAreaProps {
  attributeIcons: TechnicalDataAttributes;
  currentProduct: ProductFragmentEnhanced;
  unitSystem: UnitSystem;
}

export const AttributeIconArea = ({ attributeIcons, currentProduct, unitSystem }: AttributeIconAreaProps) => (
  <div className="-my-4 px-2 text-xxs igus-text-styles">
    {attributeIcons.map(item => {
      if (
        currentProduct.attributes &&
        currentProduct.attributes[item.id] !== null &&
        currentProduct.attributes[item.id] !== undefined
      ) {
        const label = (currentProduct.attributes[item.id] as LabeledAttribute<unknown>)?.label;
        const attributeValue = getAttributeValue<ProductAttributeValueAmountUnit>(
          currentProduct.attributes[item.id] as ProductAttribute<ProductAttributeValueAmountUnit>
        );

        const imageUrl = isTechnicalDataAttributeAndNotLegacyConfig(item) ? item.widenUrl || '' : '';

        return (
          <div
            key={`attributeIcon-${item.id}`}
            data-testid={`attributeIcon-${item.id}`}
            className="flex flex-wrap -mx-2 overflow-hidden"
          >
            <div className="my-4 mr-6 overflow-hidden" style={{ height: '50px', width: '50px' }}>
              <Image unoptimized className={styles.icon} alt={label} src={imageUrl} width={50} height={50} />
            </div>
            <div className="my-1 flex-grow-half overflow-hidden flex flex-col justify-center">
              <div className="text-xs font-semibold">{label}</div>
              <div className="text-xs font-light">{getAttributeDisplayValue(unitSystem, attributeValue)}</div>
            </div>
          </div>
        );
      }
      return null;
    })}
  </div>
);
